/**
 * Output transform for the money inputs masked with ngx-mask (`mask="separator.2"`).
 *
 * ngx-mask emits the value as a string ("1500.00"), while the forms and the API expect a
 * number, as the ngx-currency directive these inputs used before produced. An empty input
 * is 0, also as before.
 */
export function moneyMaskOutput(value: string | number | null | undefined): number {
  return value === '' || value == null ? 0 : Number(value);
}
